export default "__VITE_PUBLIC_ASSET__02e65196__"